import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(
    private title: Title,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getPath(this.route);

    this.router.events.forEach(() => {
      this.getPath(this.route);
    });
  }

  getPath(route) {
    if (
      route &&
      route.data &&
      route.data.value &&
      route.data.value.title
    ) {
      this.title.setTitle('Pague.lá | ' + route.data.value.title);
    }
  }

}
